import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ExternalIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6.75C4 5.23122 5.23122 4 6.75 4H9.25C9.66421 4 10 4.33579 10 4.75C10 5.16421 9.66421 5.5 9.25 5.5H6.75C6.05964 5.5 5.5 6.05964 5.5 6.75V17.25C5.5 17.9404 6.05964 18.5 6.75 18.5H17.25C17.9404 18.5 18.5 17.9404 18.5 17.25V14.75C18.5 14.3358 18.8358 14 19.25 14C19.6642 14 20 14.3358 20 14.75V17.25C20 18.7688 18.7688 20 17.25 20H6.75C5.23122 20 4 18.7688 4 17.25V6.75Z"
        fill="currentColor"
      />
      <path
        d="M14 4.75C14 4.33579 14.3358 4 14.75 4H19.25C19.6642 4 20 4.33579 20 4.75V9.25C20 9.66421 19.6642 10 19.25 10C18.8358 10 18.5 9.66421 18.5 9.25V6.56066L12.2803 12.7803C11.9874 13.0732 11.5126 13.0732 11.2197 12.7803C10.9268 12.4874 10.9268 12.0126 11.2197 11.7197L17.4393 5.5H14.75C14.3358 5.5 14 5.16421 14 4.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
